module.exports = __webpack_public_path__ + "img/仿真电动三角恐龙.01336449.jpg";